import { Component, Input,OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';

@Component({
  selector: 'textbox-question',
  template:`<div [formGroup]="form">
  <kendo-formfield>
  <kendo-floatinglabel  [text]="question.label">
      <kendo-textbox [formControlName]="question.key" [clearButton]="true" [id]="question.key" [disabled]=" question?.value?.length && question.disabled" (input)="forceUppercaseConditionally(this.question.key, $event);" ></kendo-textbox>
    </kendo-floatinglabel>
    <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.maxlength">Error: {{errorMax.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.minlength">Error: {{errorMin.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.uniqueKey">Error: {{errorUnique.value}}</kendo-formerror>
  </kendo-formfield>
</div>`
})
export class TextboxFormQuestionComponent  implements OnChanges {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;

  errorRequired: { key: string; value: string; };
  errorMax: { key: string; value: string; };
  errorMin: { key: string; value: string; };
  errorUnique: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) { 
      this.errorRequired = this.question.errors.find( ({ key }) => key === 'required' )
      this.errorMax = this.question.errors.find( ({ key }) => key === 'maxLength' )
      this.errorMin = this.question.errors.find( ({ key }) => key === 'minLength' )
      this.errorUnique = this.question.errors.find( ({ key }) => key === 'uniqueKey' )
    
  }

  forceUppercaseConditionally(formControlName, event) {
    if (this.question.lowerCase) {
      this.form.get(formControlName).setValue(event.target.value.toLowerCase()); 
    }
}

}